import type { FormatOptionLabelMeta } from 'react-select';
import TaskStatusBadge from '../../TaskStatusBadge';
import TaskTypeChip from '../../TaskTypeChip';
import type { FilterOption } from '../model/types';

export const formatTypeOption = (
    option: FilterOption,
    meta: FormatOptionLabelMeta<FilterOption>,
) => (
    <TaskTypeChip
        name={option.label}
        icon={option.icon}
        colors={option.colors}
        fontSize={meta.context === 'menu' ? '0.75rem' : '0.7rem'}
    />
);

export const formatStatusOption = (option: FilterOption) => (
    <TaskStatusBadge status={option.value} />
);
